import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TrackerLayoutModule} from '../../layouts/tracker/tracker-layout.module';
import {TrackerRoutingModule} from './tracker-routing.module';
import {TrackerComponent} from './tracker.component';

@NgModule({
    imports: [
        CommonModule,
        TrackerLayoutModule,
        TrackerRoutingModule
    ],
    declarations: [TrackerComponent]
})
export class TrackerModule {
}
